import { createTheme } from "@mui/material";
import { primary, secondary } from "./colors";

const theme = createTheme({
	palette: {
		primary: {
			main: secondary,
		},
		secondary: {
			main: primary,
		},
	},
	typography: {
		fontFamily: "Source Sans Variable",
	},
});

export { theme };
